/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/phone_medium'
export default icon
